@if (isVisible()) {
    <div>
        <div class="bar-startscherm__picker">
            <button class="bar-startscherm__picker-main" (click)="search()">
                <span [class]="{ 'visually-hidden': testProfiel(), 'bar-startscherm__picker-placeholder': !testProfiel() }">
                    {{ 'DOMAIN_STARTSCHERM.TEST_PROFILE.PLACEHOLDER' | i18n }}
                </span>
                @if (testProfiel()) {
                    <span> {{ testProfiel() }} </span>
                }
            </button>
            <div class="bar-startscherm__picker-actions">
                @if (testProfiel()) {
                    <button (click)="reset()" [attr.aria-label]="'DOMAIN_STARTSCHERM.TEST_PROFILE.CLEAR' | i18n">
                        <span class="fa fa-times" aria-hidden="true"></span>
                    </button>
                }
                <button (click)="search()" aria-hidden="true" tabindex="-1">
                    <span class="fa fa-search"></span>
                </button>
            </div>
        </div>
    </div>
}
